import { render, staticRenderFns } from "./email-attachments.vue?vue&type=template&id=0f073957"
import script from "./email-attachments.vue?vue&type=script&lang=ts"
export * from "./email-attachments.vue?vue&type=script&lang=ts"
import style0 from "./email-attachments.vue?vue&type=style&index=0&id=0f073957&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports